import React, { forwardRef } from 'react';
import './Banner3.css';
import Banner3 from '../../Assets/banner3.png'; // Adjust the path if needed
import Banner3Mob from '../../Assets/banner3-mob.png'; // Adjust the path if needed

const Banner = forwardRef((props,ref) => {
  return (
    <div ref={ref} id="b3" className="banner3-div">
      <div className="banner3-header"> 
        How does it work?
      </div>
      
      
      <div className="banner3-body"> 
        <img className="banner3 desktop" src={Banner3} alt="Banner3" />
        <img className="banner3 mobile" src={Banner3Mob} alt="Banner3 Mobile" />
      </div>
    </div>
  );
});

export default Banner;



// WEBPACK FOOTER //
// ./src/components/Banner3/Banner3.js